import useTranslation from "@babackapp/translations/use-translation";
import { PlusIcon } from "lucide-react";
import { useState } from "react";
import SimpleMenu from "./simpleMenu";

export default function TagPicker(props: {
  readOnly?: boolean;
  tags: string[];
  tagsPicked: string[];
  onUpdateTag: (tag: string) => void;
}) {
  const t = useTranslation();

  // State for tags selection and picked tags
  const [availableTags, setAvailableTags] = useState(props.tags || []);
  const [selectedTags, setSelectedTags] = useState(props.tagsPicked || []);

  // Update the list of selected tags
  const updateSelectedTags = (tag: string) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((t) => t !== tag));
    } else {
      setSelectedTags([...selectedTags, tag]);
    }
    props.onUpdateTag(tag);
  };

  // Prepare menu items
  const menu = availableTags.map((tag) => ({
    onClick: () => updateSelectedTags(tag),
    renderTitle: () => (
      <div className="flex flex-1">
        <div className="flex-1 justify-self-end">{tag}</div>
      </div>
    ),
  }));

  return (
    <>
      {props.readOnly ? (
        <div className="space-y-2">
          {selectedTags.length > 0 &&
            selectedTags.map((tag) => (
              <li
                key={tag}
                className="flex bg-blue-100 text-blue-800 rounded-xl px-2 items-center"
              >
                <div className="rounded-full bg-blue-800 h-1 w-1 mr-1"></div>
                {tag}
              </li>
            ))}
        </div>
      ) : (
        <div>
          <SimpleMenu
            className="h-full z-100"
            type="neutral"
            button={
              selectedTags.length === 0 ? (
                <div className="text-sm flex font-normal text-gray-400 hover:text-gray-600 cursor-pointer items-center">
                  <PlusIcon className="h-4 w-4 mr-2" />
                  {t("settings.config.addTags")}
                </div>
              ) : (
                <div className="space-y-2">
                  {selectedTags.length > 0 &&
                    selectedTags.map((tag) => (
                      <li
                        key={tag}
                        className="flex bg-blue-100 text-blue-800 rounded-xl px-2 items-center"
                      >
                        <div className="rounded-full bg-blue-800 h-1 w-1 mr-1"></div>
                        {tag}
                      </li>
                    ))}
                </div>
              )
            }
            menu={menu}
          />
        </div>
      )}
    </>
  );
}
